const normalizeValue = (value: number): string | number => (
  value < 10 ? `0${value}` : value
);

const dateTimeToString = (date: Date): string => {
  const day = normalizeValue(date.getDate());
  const month = normalizeValue(date.getMonth() + 1);
  const year = date.getFullYear();
  const hour = normalizeValue(date.getHours());
  const minute = normalizeValue(date.getMinutes());
  const second = normalizeValue(date.getSeconds());

  return `${day}.${month}.${year} ${hour}:${minute}:${second}`;
};

export default dateTimeToString;
